import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { allBlogPosts } from '../data/blogData';

const featuredSlugs = [
  "complete-guide-residential-painting-dallas",
  "kitchen-bathroom-remodeling-dallas-complete-guide",
  "mold-remediation-removal-dallas-guide"
];

const HomeBlogCards = () => {
  const featured = featuredSlugs
    .map(slug => allBlogPosts.find(p => p.slug === slug))
    .filter(Boolean);

  return (
    <div className="grid md:grid-cols-3 gap-8" data-testid="home-blog-cards">
      {featured.map(post => (
        <Link
          key={post.id}
          to={`/blog/${post.slug}`}
          className="bg-neutral-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
        >
          <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${post.heroImage}')` }} />
          <div className="p-5">
            <span className="text-xs font-semibold text-amber-600 uppercase">{post.category}</span>
            <h3 className="font-bold text-neutral-900 group-hover:text-amber-600 transition-colors mt-1 mb-2 line-clamp-2">
              {post.title.split('|')[0].trim()}
            </h3>
            <div className="flex items-center gap-2 text-sm text-neutral-500">
              <Clock className="w-4 h-4" />
              <span>{post.readTime}</span>
            </div>
            <span className="inline-flex items-center gap-1 text-amber-600 font-medium text-sm mt-3">
              Read Guide <ArrowRight className="w-3 h-3" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default HomeBlogCards;
